<template>
    <transition name="global-loading-fade">
        <div
            v-show="visible"
            class="global-loading-mask"
            role="alert"
            aria-live="assertive"
        >
            <div class="global-loading-card">
                <div class="global-loading-spinner" />
                <div class="global-loading-main">{{ mainText }}</div>
                <div v-if="subText" class="global-loading-sub">
                    {{ subText }}
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "GlobalLoading",
    data() {
        return {
            visible: false,
            mainText: "请稍后，正在处理中...",
            subText: "",
        };
    },
    methods: {
        open(opts = {}) {
            const { text, mainText, message, subText, detail } = opts || {};
            const main =
                mainText != null
                    ? mainText
                    : text != null
                      ? text
                      : message != null
                        ? message
                        : "请稍后，正在处理中...";
            const sub = subText != null ? subText : detail != null ? detail : "";
            this.mainText = String(main);
            this.subText = sub == null ? "" : String(sub);
            this.visible = true;
        },
        close() {
            this.visible = false;
        },
    },
};
</script>

